export default __webpack_public_path__ + "static/media/element_104.55a2a7e7.webp";